import React from "react";
import { useParent } from "../../../context/ParentContext";

export default function ParentFee() {
  const { selectedChild } = useParent();
  return (
    <div>
      <h4 style={{ marginBottom: 4, color: "#0f172a" }}>Fee Challans</h4>
      <p style={{ color: "#64748b", fontSize: 13 }}>
        {selectedChild
          ? `Viewing fee challans for ${selectedChild.student?.name}`
          : "No child selected"}
      </p>
      {/* TODO: fetch and display fee challans */}
    </div>
  );
}
